import babelpolyfill from 'babel-polyfill'
//内容说明： 导入vue和elementui相关
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VDistpicker from 'v-distpicker';
//import './assets/theme/theme-green/index.css'

//内容说明： 导入router路由相关
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'

//内容说明： 导入mock测试，这个可以注释掉
//import Mock from './mock'
//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

//引入自定义指令 v-perm
import '@/common/js/permissions'

//内容说明： 使用相关组件
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.component('v-distpicker',VDistpicker);
//引入axios
import axios from 'axios'
//配置axios的全局基本路径
axios.defaults.baseURL='/api'
//axios.defaults.baseURL='http://localhost:8881'
//axios.defaults.baseURL='https://ahyfyx.com/api'
//全局属性配置，在任意组件内可以使用this.$http获取axios对象
Vue.prototype.$http = axios

//NProgress.configure({ showSpinner: false });

//内容说明： 路由配置
const router = new VueRouter({
  routes
})


//===========================================我们自定义的登录拦截器
//1 使用axios前置拦截器，让所有的请求都携带uToken
axios.interceptors.request.use(config=>{
  //携带token
  let uToken =  localStorage.getItem("U-TOKEN");
  if(uToken){
    //请求头中携带token
    config.headers['U-TOKEN']=uToken;
  }
  return config;
},error => {
  Promise.reject(error);
});

//2 使用axios后置拦截器，处理没有登录请求
axios.interceptors.response.use(result=>{
  let data = result.data;//AjaxResult
  if(!data.success && data.message==="noLogin"){
    router.push({ path: '/login' });
  }
  if(!data.success && data.message==="noPermission"){
    router.push({ path: '/noPermission' });
  }
  return result;
},error => {
  Promise.reject(error);
});

//4.静态资源拦截器
//其实就是在访问静态资源路由的时候，直接放行，否则，看一下是否登录，没有就阻止放行
router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login'||to.path == '/cardLogin'||to.path == '/cardProduct' ||to.path == '/reservationOrder'||to.path == '/userReservationOrder'||to.path == '/userCardReservationOrder') {//如果是静态资源：登录，或者是注册，清除历史存储，并放行
    if(localStorage.getItem("U-TOKEN")){
      //location.reload();
      localStorage.removeItem('U-TOKEN');
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('permissions');
    }
    next();//放行
  } else {//如果不是静态资源
    let user = JSON.parse(localStorage.getItem('loginInfo'));//获取登录信息
    if (user) {//获取到了
      next();//去获取资源
    } else {
      next({ path: '/login' });//返回登陆页面
    }
  }
})

//内容说明： 创建Vue对象，挂载 #app元素 ， 见Vue.app
new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')

//处理页面刷新动态路由失效问题
/*
initIndexRouters();
function initIndexRouters(){
  if(!localStorage.menus){
    return;
  }
  //防止重复配置路由
  if(router.options.routes.length>6){
    return;
  }
  let menus = localStorage.getItem('menus');
  menus = JSON.parse(menus);
  let tempRouters = [];
  menus.forEach(menu=>{
    let indexRouter = {
      path: '/',
      iconCls: menu.icon,
      name: menu.name,
      component: resolve => require(['@/views/Home'], resolve),
      children: []
    }
    menu.children.forEach(cMenu=>{
      let cr = {
        path: cMenu.url,
        name: cMenu.name,
        component: resolve => require(['@/views/'+cMenu.component], resolve)
      }
      indexRouter.children.push(cr)
    })
    tempRouters.push(indexRouter)
    router.options.routes.push(indexRouter)
  })
  //动态路由配置
  router.addRoutes(tempRouters);
}*/



// WEBPACK FOOTER //
// ./src/main.js